// LinkSubstring.js
'use strict';
import { connect } from 'react-redux';

import LinkSubstring from '../component/LinkSubstring.jsx';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { HASHTAG_REGEX_PATTERN } from '../RemoteConfigKeys.js';

const mapStateToProps = state => {
  return {
    hashtagRegexPattern: getRemoteConfigData(state, HASHTAG_REGEX_PATTERN),
  };
};

export default connect(mapStateToProps, null)(LinkSubstring);
